import { useMember } from "../../context/memberContext";
import { SP } from "../../http/serviceportalApi";
import { useTranslations } from "../../hooks/useTranslations";
import DepartmentApps from "../DepartmentApps";
import { DOCUMENTS_LIST_ID } from "../documents/DocumentsList";
import { getAuthorizedLuidsByDocumentSet } from "../documents/utils";
import Page from "../ui/Page";
import PageSection from "../ui/PageSection";
import QuickAccess, { QuickAccessItemProps } from "../ui/QuickAccess";

const Payroll = () => {
  const { i18n } = useTranslations();
  const { member, status } = useMember();
  const quickAccessItems = member ? getQuickAccessItems(member, i18n) : [];

  return (
    <Page
      title={i18n.departments.payroll.title}
      description={i18n.departments.payroll.description}
      isLoading={status === "validating"}
    >
      {quickAccessItems.length > 0 && (
        <PageSection title={i18n.nav.quickAccess}>
          <QuickAccess items={quickAccessItems} />
        </PageSection>
      )}

      <PageSection title={i18n.nav.apps}>
        <DepartmentApps department="payroll" />
      </PageSection>
    </Page>
  );
};

const quickAccessDocumentSets: SP.DocumentSetType[] = [
  "arbeitsvertraege",
  "lohn-rundschreiben",
  "lohnauswertung",
  "prov-lohnstreifen",
];

const getQuickAccessItems = (
  member: SP.Member,
  i18n: ReturnType<typeof useTranslations>["i18n"],
) =>
  quickAccessDocumentSets.reduce((state: QuickAccessItemProps[], value) => {
    if (getAuthorizedLuidsByDocumentSet(member, value).length > 0) {
      const props: QuickAccessItemProps = {
        name: i18n.documentSet[value],
        type: "documents",
        to: `/dokumente/personalberatung/${value}#${DOCUMENTS_LIST_ID}`,
      };
      return [...state, props];
    }
    return state;
  }, []);

export default Payroll;
